import { Control, Controller, RegisterOptions } from "react-hook-form";
import { Toggle } from "../shadcn/toggle";
import { NoxusFormLabel } from "./NoxusFormLabel";
import { Lock, LucideProps, Unlock, Settings } from "lucide-react";
import { NoxusTooltip } from "../UI/NoxusTooltip";

const iconMap = {
  Lock,
  Unlock,
  Settings,
};

interface IToggleButtonInput {
  name: string;
  label?: string;
  tooltip?: string;
  icon: string;
  toggledIcon?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  isDisabled?: boolean;
}

const ToggleButton = (props: IToggleButtonInput) => {
  const DefaultIcon = iconMap[props.icon as keyof typeof iconMap] || Settings;
  const AlternateIcon = props.toggledIcon
    ? iconMap[props.toggledIcon as keyof typeof iconMap]
    : null;

  const IconComponent: React.ComponentType<LucideProps> =
    props.value && AlternateIcon ? AlternateIcon : DefaultIcon;

  return (
    <>
      {props.label && <NoxusFormLabel label={props.label} name={props.name} />}
      <NoxusTooltip content={props.tooltip} placement="top" asChild>
        <Toggle
          pressed={props.value}
          onPressedChange={props.onChange}
          disabled={props.isDisabled}
          variant="outline"
        >
          <IconComponent size="1.5rem" strokeWidth="1.5px" />
        </Toggle>
      </NoxusTooltip>
    </>
  );
};

interface IToggleButtonField {
  name: string;
  placeholder?: string;
  label?: string;
  tooltip?: string;
  rules?: RegisterOptions;
  control: Control<any>;
  isDisabled?: boolean;
  icon: string;
  toggledIcon?: string;
}

const ToggleButtonField = (props: IToggleButtonField) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={props.rules}
      render={({ field: { onChange, value } }) => {
        return (
          <ToggleButton
            name={props.name}
            label={props.label}
            value={value}
            onChange={onChange}
            tooltip={props.tooltip}
            icon={props.icon}
            toggledIcon={props.toggledIcon}
            isDisabled={props.isDisabled}
          />
        );
      }}
    />
  );
};

export default ToggleButtonField;
